module.exports = __webpack_public_path__ + "img/aboutImage.d9a862bc.jpg";